import React from "react";
import { ArrowRight } from "lucide-react";
import {
  ProductChangeCandidate,
  ProductChangeOption,
} from "../../interfaces/sales";

export interface ReplacementSelectionStepProps {
  candidates: ProductChangeCandidate[];
  replacements: Record<string, string>;
  onReplacementChange: (uuidSaleProduct: string, uuidProduct: string) => void;
}

/**
 * YOSHI-10261: paso 2 del cambio de producto. Se cambian uno por uno: cada producto seleccionado
 * elige su reemplazo entre las opciones que el backend ya validó (misma concesión y mismo precio).
 */
export const ReplacementSelectionStep: React.FC<
  ReplacementSelectionStepProps
> = ({ candidates, replacements, onReplacementChange }) => {
  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-600">
        Elige el producto correcto para cada uno. Solo se listan productos de la
        misma concesión y del mismo precio exacto.
      </p>
      <div className="max-h-80 space-y-3 overflow-y-auto pr-1">
        {candidates.map((candidate) => (
          <div
            key={candidate.uuid_sale_product}
            className="space-y-2 rounded-lg border border-gray-200 bg-white p-3"
          >
            <div className="flex items-center gap-2 text-sm">
              <span className="font-medium text-gray-900">
                {candidate.product} × {candidate.quantity}
              </span>
              <ArrowRight className="h-4 w-4 shrink-0 text-gray-400" />
              <span className="text-gray-500">
                ${candidate.price.toFixed(2)}
              </span>
            </div>
            <select
              className="w-full rounded-lg border border-gray-200 p-2 text-sm text-gray-900 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900"
              value={replacements[candidate.uuid_sale_product] || ""}
              onChange={(event) =>
                onReplacementChange(
                  candidate.uuid_sale_product,
                  event.target.value,
                )
              }
            >
              <option value="">Selecciona el producto correcto</option>
              {candidate.options.map((option: ProductChangeOption) => (
                <option
                  key={option.uuid}
                  value={option.uuid}
                >
                  {option.name}
                  {option.category ? ` · ${option.category}` : ""}
                </option>
              ))}
            </select>
          </div>
        ))}
      </div>
    </div>
  );
};
